import { get, post, put, patch } from "../index";
import AdmeetRoutes from "./AdMeet.Routes";

const AdmeetServices = {
  getAllAdmeets: async (catId, search, page, limit, type) => {
    let params = `?page=${page}&limit=${limit}&type=${type}`;
    if (catId) params += `&category=${catId}`
    if (search) params += `&title=${search}`
    const result = await get(AdmeetRoutes.getAllAdMeets + params
    );
    return result;
  },
  createAdmeet: async (obj) => {
    const result = await post(AdmeetRoutes.createAdMeet, obj);
    return result;
  },

  updateAdmeet: async (id, obj) => {
    const result = await put(AdmeetRoutes.updateAdMeet + `/${id}`, obj);
    return result;
  },

  getAdMeetRegistrations: async (id) => {
    const result = await get(AdmeetRoutes.getAdMeetRegistration + `?blogId=${id}`);
    return result;
  },

  approveBlog: async (id, obj) => {
    const result = await patch(AdmeetRoutes.approveBlog + `/${id}`, obj);
    return result;
  }
}

export default AdmeetServices;